<template>
  <flipper
    :status="maquina.status"
    class="container"
    style="height: 100%; width: 50%"
    :active="field === 'oee'"
  >
    <Frame title="Máquina">
      <button
        v-if="fake"
        style="position:absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: transparent; border: none"
        @click="fakeStatusChange"
      ></button>
      <div class="wrapper">
        <div :class="['general-info', field !== 'oee' && 'higher']">
          <div
            :class="[
              field !== 'oee' ? 'disponibilidade' : 'oee-style'
            ]"
          >
            <rlabel class="machine-name" :text="maquina.codigo"></rlabel>
            <div
              :class="[
                'machine-info',
                field !== 'oee' && 'disponibilidade-info'
              ]"
              v-if="maquina.ordem"
            >
              <span>
                <i class="material-icons md-8">assignment_late</i>
                {{
                maquina.ordem.substring(0, Math.min(maquina.ordem.length, 10))
                }}
              </span>
              <span>
                <i class="material-icons md-8">build</i>
                {{
                maquina.peca.substring(0, Math.min(maquina.peca.length, 10))
                }}
              </span>
            </div>
          </div>
          <FrameContent style="width: 50%;height: 100%" v-if="field === 'disponibilidade'">
            <ChartContainer>
              <Doughnut color="#36A2EB" v-bind:complete="maquina.disponibilidade" />
            </ChartContainer>
          </FrameContent>
          <FrameContent style="width: 50%;height: 100%" v-if="field === 'qualidade'">
            <ChartContainer>
              <Doughnut color="#90A4AE" v-bind:complete="maquina.qualidade" />
            </ChartContainer>
          </FrameContent>
        </div>
        <div :class="['main-chart', field !== 'oee' && 'stop-chart']">
          <Frame title="OEE" v-if="field === 'oee'">
            <FrameContent>
              <ChartContainer>
                <Doughnut color="#006064" v-bind:complete="maquina.oee" />
              </ChartContainer>
            </FrameContent>
          </Frame>
          <Frame
            title="Principais Paradas"
            v-else-if="field === 'disponibilidade'"
            style="height: 100%"
          >
            <chart-container>
              <bar-chart
                color="#E05959"
                label="Disponibilidade"
                v-bind:valores="principaisParadas(maquina.indice)"
                smallLabel
                suffix="h"
                :offset="-15"
              ></bar-chart>
            </chart-container>
          </Frame>
          <Frame title="Principais Defeitos" v-else-if="field === 'qualidade'" style="height: 100%">
            <chart-container>
              <bar-chart
                color="#2Aa987"
                label="Disponibilidade"
                v-bind:valores="principaisDefeitos(maquina.indice)"
                smallLabel
                :offset="-15"
              ></bar-chart>
            </chart-container>
          </Frame>
        </div>
        <div class="status">
          <Frame title="Status" v-if="field === 'oee'">
            <div
              class="display-status"
              :class="{
                produzindo: validaProd(maquina.status),
                parada: validaParada(maquina.status),
                ociosa: validaOciosa(maquina.status),
                setup: validaSetup(maquina.status)
              }"
            >
              <p display-tag>
                {{ maquina.status }}
                <font-awesome-icon
                  class="arrow"
                  icon="chevron-circle-up"
                  v-if="maquina.status === 'Produção' && maquina.atraso >= 0"
                />
                <font-awesome-icon
                  v-if="maquina.status === 'Produção' && maquina.atraso < 0"
                  class="arrow arrow-down"
                  icon="chevron-circle-up"
                />
              </p>
              <span display-info v-if="maquina.status !== 'Produção'">{{ maquina.tempoEstado }}</span>
              <div display-info v-if="maquina.status === 'Produção'">
                <span display-info class="info-progress">
                  {{
                  maquina.progress
                  }}
                </span>
                <span class="info-total">/ {{ maquina.total }}</span>
              </div>
              <div display-info v-if="maquina.status === 'Produção'">
                <span display-info class="info-progress">00:15:00</span>
              </div>
            </div>
          </Frame>
        </div>
      </div>
    </Frame>
  </flipper>
</template>

<script>
import Frame from "../Frame.vue";
import Doughnut from "../charts/Doughnut.js";
import ChartContainer from "../ChartContainer.vue";
import FrameContent from "../FrameContent.vue";

import ResponsiveLabel from "../ResponsiveLabel.vue";
import Bar from "../charts/HorizontalBar.js";
import Flipper from "../FlippingCard.vue";

import fakeData from "../../store/fakeData.js";

export default {
  name: "Machine8",
  components: {
    Frame,
    Doughnut,
    ChartContainer,
    FrameContent,
    rlabel: ResponsiveLabel,
    "bar-chart": Bar,
    flipper: Flipper
  },
  props: {
    maquina: Object,
    field: String
  },
  methods: {
    validaProd(p) {
      let result = false;
      if (p === "Produção") result = true;

      return result;
    },
    validaParada(p) {
      let result = false;
      if (p === "Parada") result = true;

      return result;
    },
    validaOciosa(p) {
      let result = false;
      if (p === "Ocioso") result = true;

      return result;
    },
    validaSetup(p) {
      let result = false;
      if (p === "Setup") result = true;

      return result;
    },
    fakeStatusChange() {
      if (this.maquina.status === "Produção")
        fakeData[this.maquina.indice - 1].status = "Parada";
      else if (this.maquina.status === "Parada")
        fakeData[this.maquina.indice - 1].status = "Ocioso";
      else if (this.maquina.status === "Ocioso")
        fakeData[this.maquina.indice - 1].status = "Setup";
      else if (this.maquina.status === "Setup")
        fakeData[this.maquina.indice - 1].status = "Produção";
    }
  },
  computed: {
    fake() {
      return this.$store.state.fake;
    },
    principaisParadas() {
      return index => ({
        labels: [
          "Injustificada",
          "Manutenção Corretiva",
          "Troca de Ferramenta"
        ],
        valores:
          index === 1
            ? [358.33, 140.12, 140]
            : index === 2
            ? [220.2, 210.42, 134]
            : index === 3
            ? [300, 298.7, 103.5]
            : index === 4
            ? [321.49, 90, 82.3]
            : index === 5
            ? [120, 20, 10]
            : index === 6
            ? [134.8, 101.3, 58.2]
            : index == 7
            ? [402, 10.2, 3.8]
            : [304.2, 190, 13.2]
      });
    },
    principaisDefeitos() {
      return index => ({
        labels: ["Quebrada", "Corte Incorreto", "Porosidade"],
        valores:
          index === 1
            ? [135, 72, 66]
            : index === 2
            ? [240, 91, 77]
            : index === 3
            ? [174, 120, 118]
            : index === 4
            ? [300, 128, 120]
            : index === 5
            ? [120, 20, 10]
            : index === 6
            ? [140, 120, 20]
            : index == 7
            ? [432, 310, 120]
            : [90, 81, 72]
      });
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  padding: 0 0.8rem;
}

.disponibilidade {
  width: 50%;
  display: flex;
  flex-direction: column;
}

.oee-style {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.container {
  max-width: 24.7%;
}

.general-info {
  height: 6rem;
  display: flex;
}

.higher {
  height: 12rem;
}

.machine-name {
  font-size: 4rem;
  flex-basis: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.machine-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-basis: 40%;
  justify-content: center;
  font-size: 2rem;
}

.disponibilidade-info {
  align-items: flex-start;
}

.main-chart {
  height: 50%;
  border-radius: 1rem;
}

.stop-chart {
  height: calc(100% - 12rem);
}

.status {
  height: calc(50% - 6rem);
  border-radius: 1rem;
}

.display-status {
  height: 100%;
  background-size: 140%;
  background-position: 50%, 50%;
  font-size: 3rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.material-icons.md-8 {
  font-size: 1em;
  position: relative;
  bottom: -0.2em;
}

.produzindo {
  background-image: linear-gradient(135deg, #388e3c, transparent 64%);
  background-image: linear-gradient(
    135deg,
    var(--color-success),
    transparent 64%
  );
}

.parada {
  background-image: linear-gradient(135deg, #b71c1c, transparent 64%);
  background-image: linear-gradient(135deg, var(--color-stop), transparent 64%);
}

.ociosa {
  background-image: linear-gradient(135deg, #1e88e5, transparent 64%);
  background-image: linear-gradient(
    135deg,
    var(--color-danger),
    transparent 64%
  );
}

.setup {
  background-image: linear-gradient(135deg, #20c997, transparent 64%);
  background-image: linear-gradient(
    135deg,
    var(--color-setup),
    transparent 64%
  );
}

.info-progress {
  font-size: 0.8em;
}

.info-total {
  font-size: 0.5em;
  position: relative;
  top: 0.1em;
  float: right;
  margin-right: 10%;
}

.arrow {
  color: #388e3c;
  color: var(--color-success);
  font-size: 0.6em;
}

.arrow-down {
  transform: rotate(180deg);
  color: #b71c1c;
  color: var(--color-stop);
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .machine-info > * {
    display: block;
  }
}
</style>
